import { FormWithRedux } from '../FormWithRedux';
import { GenericFrom } from './GenericForm';
import { FormLoader } from '../FormLoader';
 
export class EnvironmentInfoForm extends FormWithRedux {

    get pathwayId() {
        return 'environmentInfoForm';
    }

    constructor() {
        super('mainForm', null);
    }

    subform(identifier) {
        return FormLoader.form(this.pathwayId, identifier);
    }

    formDetail(identifier) {
        return FormLoader.formDetail(this.pathwayId, identifier);
    }

    generateSubform(identifier) {
        return new GenericFrom(identifier, this.pathwayId);
    }

    shouldDisplayFormDetailForIdentifier() {
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return true;
    }

    getValueType() {
        return 'string';
    }

    editingValidation(){
        return [];
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/sharedForms/EnvironmentInfoForm.js